export const germanyUniversities = {
  "tu-munich": {
    slug: "tu-munich", country: "germany",
    name: "Technical University of Munich", shortName: "TU Munich", flag: "🇩🇪",
    city: "Munich, Bavaria", founded: 1868, qsRank: "#37 QS World 2025",
    heroImg: "https://images.unsplash.com/photo-1467269204594-9661b134dd2b?q=80&w=1600&auto=format&fit=crop",
    campusImg: "https://images.unsplash.com/photo-1541339907198-e08756dedf3f?q=80&w=900&auto=format&fit=crop",
    overview: "TU Munich is Germany's top-ranked technical university, consistently placed among Europe's elite. Known for engineering, computer science, and life sciences, it boasts 17 Nobel laureates among alumni and faculty. Strong industry ties with BMW, Siemens, and MAN make it a launchpad for global careers.",
    tuition: { domestic: "€0 (semester fee ~€150)", international: "€0 (semester fee ~€150)" },
    living: "€900–€1,300/mo", ielts: "6.5+", gre: "Required for some programs",
    topCourses: [
      { name: "M.Sc. Informatics (Computer Science)", duration: "2 years", language: "English" },
      { name: "M.Sc. Electrical Engineering", duration: "2 years", language: "English/German" },
      { name: "M.Sc. Robotics, Cognition, Intelligence", duration: "2 years", language: "English" },
      { name: "M.Sc. Management & Technology", duration: "2 years", language: "English" },
      { name: "M.Sc. Biomedical Engineering", duration: "2 years", language: "English" },
    ],
    placementStats: { rate: "94%", avgSalary: "€55,000–€75,000", topEmployers: ["BMW Group", "Siemens", "Google", "McKinsey", "SAP"] },
    intakes: ["October (Winter Semester)", "April (Summer Semester — limited)"], istpStudents: 18,
  },
 
  "lmu-munich": {
    slug: "lmu-munich", country: "germany",
    name: "Ludwig Maximilian University of Munich", shortName: "LMU Munich", flag: "🇩🇪",
    city: "Munich, Bavaria", founded: 1472, qsRank: "#54 QS World 2025",
    heroImg: "https://images.unsplash.com/photo-1467269204594-9661b134dd2b?q=80&w=1600&auto=format&fit=crop",
    campusImg: "https://images.unsplash.com/photo-1541339907198-e08756dedf3f?q=80&w=900&auto=format&fit=crop",
    overview: "LMU Munich is Germany's most prestigious comprehensive university with 43 Nobel laureates among its alumni. Its strength spans medicine, law, humanities, and economics — ideal for students seeking a broader academic environment in one of Europe's most liveable cities.",
    tuition: { domestic: "€0", international: "€0" },
    living: "€900–€1,300/mo", ielts: "6.5+", gre: "Required for some programs",
    topCourses: [
      { name: "M.Sc. Data Science", duration: "2 years", language: "English" },
      { name: "M.Sc. Economics (MECS)", duration: "2 years", language: "English" },
      { name: "M.Sc. Neurosciences", duration: "2 years", language: "English" },
      { name: "MBA — Munich Business School", duration: "2 years", language: "English" },
    ],
    placementStats: { rate: "91%", avgSalary: "€53,000–€72,000", topEmployers: ["Allianz", "MAN", "BMW", "Google", "Bain & Company"] },
    intakes: ["October (Winter Semester)", "April (limited)"], istpStudents: 14,
  },

  "heidelberg": {
    slug: "heidelberg", country: "germany",
    name: "Heidelberg University", shortName: "Heidelberg", flag: "🇩🇪",
    city: "Heidelberg, Baden-Württemberg", founded: 1386, qsRank: "#64 QS World 2025",
    heroImg: "https://images.unsplash.com/photo-1562113820-c13ad6e08b07?q=80&w=1600&auto=format&fit=crop",
    campusImg: "https://images.unsplash.com/photo-1541339907198-e08756dedf3f?q=80&w=900&auto=format&fit=crop",
    overview: "Germany's oldest university (est. 1386) and a research powerhouse with 56 Nobel laureates. Heidelberg excels in medicine, life sciences, and humanities. Its picturesque castle-town campus creates an unparalleled academic atmosphere.",
    tuition: { domestic: "€0", international: "€0" },
    living: "€800–€1,100/mo", ielts: "6.5+", gre: "Program-dependent",
    topCourses: [
      { name: "M.Sc. Molecular Biosciences", duration: "2 years", language: "English" },
      { name: "M.Sc. Computer & Data Science", duration: "2 years", language: "English" },
      { name: "MBA — Heidelberg Business School", duration: "1–2 years", language: "English" },
      { name: "M.Sc. Physics", duration: "2 years", language: "English/German" },
    ],
    placementStats: { rate: "92%", avgSalary: "€50,000–€70,000", topEmployers: ["BASF", "Roche", "SAP", "Deutsche Bank", "Bosch"] },
    intakes: ["October (Winter Semester)"], istpStudents: 9,
  },

  "rwth-aachen": {
    slug: "rwth-aachen", country: "germany",
    name: "RWTH Aachen University", shortName: "RWTH Aachen", flag: "🇩🇪",
    city: "Aachen, North Rhine-Westphalia", founded: 1870, qsRank: "#106 QS World 2025",
    heroImg: "https://images.unsplash.com/photo-1503614472-8c93d56e92ce?q=80&w=1600&auto=format&fit=crop",
    campusImg: "https://images.unsplash.com/photo-1541339907198-e08756dedf3f?q=80&w=900&auto=format&fit=crop",
    overview: "RWTH Aachen is Germany's largest technical university with 45,000+ students. One of Europe's best for mechanical and automotive engineering. Its location bordering Belgium and the Netherlands makes it internationally connected.",
    tuition: { domestic: "€0", international: "€0" },
    living: "€750–€1,050/mo", ielts: "6.0+", gre: "Not required",
    topCourses: [
      { name: "M.Sc. Mechanical Engineering", duration: "2 years", language: "English" },
      { name: "M.Sc. Automotive Engineering", duration: "2 years", language: "English" },
      { name: "M.Sc. Computer Science", duration: "2 years", language: "English" },
      { name: "M.Sc. Industrial Engineering", duration: "2 years", language: "English" },
    ],
    placementStats: { rate: "93%", avgSalary: "€52,000–€70,000", topEmployers: ["Ford", "Volkswagen", "ThyssenKrupp", "Airbus", "Bosch"] },
    intakes: ["October (Winter Semester)"], istpStudents: 12,
  },

  "kit-karlsruhe": {
    slug: "kit-karlsruhe", country: "germany",
    name: "Karlsruhe Institute of Technology", shortName: "KIT", flag: "🇩🇪",
    city: "Karlsruhe, Baden-Württemberg", founded: 1825, qsRank: "#119 QS World 2025",
    heroImg: "https://images.unsplash.com/photo-1467269204594-9661b134dd2b?q=80&w=1600&auto=format&fit=crop",
    campusImg: "https://images.unsplash.com/photo-1541339907198-e08756dedf3f?q=80&w=900&auto=format&fit=crop",
    overview: "KIT is one of Germany's top science and engineering institutions, merging a technical university with a major national research centre. World-class in physics, computer science, and energy technology.",
    tuition: { domestic: "€0", international: "€0" },
    living: "€700–€1,000/mo", ielts: "6.0+", gre: "Not required",
    topCourses: [
      { name: "M.Sc. Computer Science", duration: "2 years", language: "English" },
      { name: "M.Sc. Electrical Engineering", duration: "2 years", language: "English" },
      { name: "M.Sc. Physics", duration: "2 years", language: "English/German" },
      { name: "M.Sc. Mechanical Engineering", duration: "2 years", language: "English" },
    ],
    placementStats: { rate: "93%", avgSalary: "€53,000–€71,000", topEmployers: ["SAP", "ABB", "EnBW", "Bosch", "Daimler"] },
    intakes: ["October (Winter Semester)"], istpStudents: 8,
  },

  "humboldt-berlin": {
    slug: "humboldt-berlin", country: "germany",
    name: "Humboldt University of Berlin", shortName: "HU Berlin", flag: "🇩🇪",
    city: "Berlin", founded: 1810, qsRank: "#120 QS World 2025",
    heroImg: "https://images.unsplash.com/photo-1467269204594-9661b134dd2b?q=80&w=1600&auto=format&fit=crop",
    campusImg: "https://images.unsplash.com/photo-1541339907198-e08756dedf3f?q=80&w=900&auto=format&fit=crop",
    overview: "One of Europe's most historic universities, alma mater of Karl Marx, Albert Einstein, and Hegel. Humboldt invented the modern research university model. Strong in natural sciences, humanities, and law.",
    tuition: { domestic: "€0", international: "€0" },
    living: "€800–€1,100/mo", ielts: "6.5+", gre: "Program-dependent",
    topCourses: [
      { name: "M.Sc. Computer Science", duration: "2 years", language: "English/German" },
      { name: "M.Sc. Biophysics", duration: "2 years", language: "English" },
      { name: "M.Sc. Statistics", duration: "2 years", language: "English" },
    ],
    placementStats: { rate: "89%", avgSalary: "€48,000–€65,000", topEmployers: ["Deutsche Bank", "Zalando", "Bayer", "Axel Springer", "Bundesbank"] },
    intakes: ["October (Winter Semester)"], istpStudents: 7,
  },

  "fu-berlin": {
    slug: "fu-berlin", country: "germany",
    name: "Freie Universität Berlin", shortName: "FU Berlin", flag: "🇩🇪",
    city: "Berlin", founded: 1948, qsRank: "#98 QS World 2025",
    heroImg: "https://images.unsplash.com/photo-1467269204594-9661b134dd2b?q=80&w=1600&auto=format&fit=crop",
    campusImg: "https://images.unsplash.com/photo-1541339907198-e08756dedf3f?q=80&w=900&auto=format&fit=crop",
    overview: "A leading research university in Berlin with excellence in political science, history, and medicine. Part of Germany's Universities Excellence Initiative. International outlook with strong global partnerships.",
    tuition: { domestic: "€0", international: "€0" },
    living: "€800–€1,100/mo", ielts: "6.5+", gre: "Program-dependent",
    topCourses: [
      { name: "M.Sc. Bioinformatics", duration: "2 years", language: "English" },
      { name: "M.A. North American Studies", duration: "2 years", language: "English" },
      { name: "M.Sc. Mathematics", duration: "2 years", language: "English/German" },
    ],
    placementStats: { rate: "88%", avgSalary: "€47,000–€63,000", topEmployers: ["EU Commission", "McKinsey", "Deutsche Welle", "Charité", "WHO"] },
    intakes: ["October (Winter Semester)"], istpStudents: 6,
  },

  "tu-berlin": {
    slug: "tu-berlin", country: "germany",
    name: "Technical University of Berlin", shortName: "TU Berlin", flag: "🇩🇪",
    city: "Berlin", founded: 1879, qsRank: "#154 QS World 2025",
    heroImg: "https://images.unsplash.com/photo-1467269204594-9661b134dd2b?q=80&w=1600&auto=format&fit=crop",
    campusImg: "https://images.unsplash.com/photo-1541339907198-e08756dedf3f?q=80&w=900&auto=format&fit=crop",
    overview: "A top technical university in Germany's startup capital Berlin. Strong in engineering, urban planning, and sustainability sciences. Close ties to Berlin's booming tech and startup ecosystem.",
    tuition: { domestic: "€0", international: "€0" },
    living: "€800–€1,200/mo", ielts: "6.0+", gre: "Not required",
    topCourses: [
      { name: "M.Sc. Computer Engineering", duration: "2 years", language: "English" },
      { name: "M.Sc. Urban Design", duration: "2 years", language: "English" },
      { name: "M.Sc. Industrial Engineering", duration: "2 years", language: "English" },
      { name: "M.Sc. Electrical Engineering", duration: "2 years", language: "English" },
    ],
    placementStats: { rate: "91%", avgSalary: "€50,000–€68,000", topEmployers: ["Siemens", "Deutsche Bahn", "SAP", "Volkswagen", "Airbus"] },
    intakes: ["October (Winter Semester)", "April (Summer Semester)"], istpStudents: 10,
  },

  "tu-dresden": {
    slug: "tu-dresden", country: "germany",
    name: "TU Dresden", shortName: "TU Dresden", flag: "🇩🇪",
    city: "Dresden, Saxony", founded: 1828, qsRank: "#237 QS World 2025",
    heroImg: "https://images.unsplash.com/photo-1467269204594-9661b134dd2b?q=80&w=1600&auto=format&fit=crop",
    campusImg: "https://images.unsplash.com/photo-1541339907198-e08756dedf3f?q=80&w=900&auto=format&fit=crop",
    overview: "A leading technical university in eastern Germany. Excellent for materials science, biomedical engineering, and transportation engineering. Part of Germany's Excellence Strategy.",
    tuition: { domestic: "€0", international: "€0" },
    living: "€650–€950/mo", ielts: "6.0+", gre: "Not required",
    topCourses: [
      { name: "M.Sc. Mechatronics", duration: "2 years", language: "English" },
      { name: "M.Sc. Transportation Engineering", duration: "2 years", language: "English" },
      { name: "M.Sc. Materials Science", duration: "2 years", language: "English" },
    ],
    placementStats: { rate: "90%", avgSalary: "€48,000–€65,000", topEmployers: ["Infineon", "Volkswagen", "Robert Bosch", "T-Systems", "Siemens"] },
    intakes: ["October (Winter Semester)"], istpStudents: 7,
  },

  "uni-hamburg": {
    slug: "uni-hamburg", country: "germany",
    name: "University of Hamburg", shortName: "Uni Hamburg", flag: "🇩🇪",
    city: "Hamburg", founded: 1919, qsRank: "#179 QS World 2025",
    heroImg: "https://images.unsplash.com/photo-1467269204594-9661b134dd2b?q=80&w=1600&auto=format&fit=crop",
    campusImg: "https://images.unsplash.com/photo-1541339907198-e08756dedf3f?q=80&w=900&auto=format&fit=crop",
    overview: "Northern Germany's largest university. Strong in law, business, climate science, and biology. Hamburg is one of Europe's top port and media cities with excellent employment prospects.",
    tuition: { domestic: "€0", international: "€0" },
    living: "€800–€1,200/mo", ielts: "6.0+", gre: "Program-dependent",
    topCourses: [
      { name: "M.Sc. Climate Sciences", duration: "2 years", language: "English" },
      { name: "M.Sc. Molecular Life Sciences", duration: "2 years", language: "English" },
      { name: "LLM — International Business Law", duration: "1 year", language: "English" },
    ],
    placementStats: { rate: "88%", avgSalary: "€47,000–€64,000", topEmployers: ["Airbus", "Hapag-Lloyd", "Beiersdorf", "Otto Group", "Hamburg Port Authority"] },
    intakes: ["October (Winter Semester)"], istpStudents: 5,
  },

  "uni-cologne": {
    slug: "uni-cologne", country: "germany",
    name: "University of Cologne", shortName: "Uni Cologne", flag: "🇩🇪",
    city: "Cologne, NRW", founded: 1388, qsRank: "#200 QS World 2025",
    heroImg: "https://images.unsplash.com/photo-1467269204594-9661b134dd2b?q=80&w=1600&auto=format&fit=crop",
    campusImg: "https://images.unsplash.com/photo-1541339907198-e08756dedf3f?q=80&w=900&auto=format&fit=crop",
    overview: "One of Germany's oldest and largest universities with 50,000+ students. Particularly strong in economics, management, and social sciences. Located in Germany's media and business capital.",
    tuition: { domestic: "€0", international: "€0" },
    living: "€750–€1,050/mo", ielts: "6.0+", gre: "Not required",
    topCourses: [
      { name: "M.Sc. Economics", duration: "2 years", language: "English" },
      { name: "M.Sc. Management", duration: "2 years", language: "English" },
      { name: "M.Sc. Information Systems", duration: "2 years", language: "English" },
    ],
    placementStats: { rate: "89%", avgSalary: "€48,000–€65,000", topEmployers: ["Deutsche Telekom", "BASF", "Deloitte", "Ford Cologne", "PwC"] },
    intakes: ["October (Winter Semester)"], istpStudents: 6,
  },

  "uni-frankfurt": {
    slug: "uni-frankfurt", country: "germany",
    name: "Goethe University Frankfurt", shortName: "Goethe Frankfurt", flag: "🇩🇪",
    city: "Frankfurt, Hesse", founded: 1914, qsRank: "#301 QS World 2025",
    heroImg: "https://images.unsplash.com/photo-1467269204594-9661b134dd2b?q=80&w=1600&auto=format&fit=crop",
    campusImg: "https://images.unsplash.com/photo-1541339907198-e08756dedf3f?q=80&w=900&auto=format&fit=crop",
    overview: "Located in Europe's financial capital. Goethe University is especially strong in finance, economics, and life sciences with close ties to the European Central Bank and Frankfurt's major banks.",
    tuition: { domestic: "€0", international: "€0" },
    living: "€800–€1,200/mo", ielts: "6.0+", gre: "Not required",
    topCourses: [
      { name: "M.Sc. Finance", duration: "2 years", language: "English" },
      { name: "M.Sc. Money & Finance", duration: "2 years", language: "English" },
      { name: "M.Sc. Biochemistry", duration: "2 years", language: "English" },
    ],
    placementStats: { rate: "90%", avgSalary: "€52,000–€72,000", topEmployers: ["Deutsche Bank", "ECB", "DWS", "Commerzbank", "EY"] },
    intakes: ["October (Winter Semester)"], istpStudents: 8,
  },

  "uni-stuttgart": {
    slug: "uni-stuttgart", country: "germany",
    name: "University of Stuttgart", shortName: "Uni Stuttgart", flag: "🇩🇪",
    city: "Stuttgart, Baden-Württemberg", founded: 1829, qsRank: "#328 QS World 2025",
    heroImg: "https://images.unsplash.com/photo-1467269204594-9661b134dd2b?q=80&w=1600&auto=format&fit=crop",
    campusImg: "https://images.unsplash.com/photo-1541339907198-e08756dedf3f?q=80&w=900&auto=format&fit=crop",
    overview: "Home of Mercedes-Benz and Porsche — Stuttgart offers unparalleled access to the automotive industry. Strong in aerospace engineering, simulation technology, and architecture.",
    tuition: { domestic: "€0", international: "€0" },
    living: "€750–€1,100/mo", ielts: "6.0+", gre: "Not required",
    topCourses: [
      { name: "M.Sc. Aerospace Engineering", duration: "2 years", language: "English" },
      { name: "M.Sc. Simulation Technology", duration: "2 years", language: "English" },
      { name: "M.Sc. Civil Engineering", duration: "2 years", language: "English" },
    ],
    placementStats: { rate: "92%", avgSalary: "€53,000–€70,000", topEmployers: ["Mercedes-Benz", "Porsche", "Bosch", "Daimler Truck", "Zeiss"] },
    intakes: ["October (Winter Semester)"], istpStudents: 9,
  },

  "uni-bonn": {
    slug: "uni-bonn", country: "germany",
    name: "University of Bonn", shortName: "Uni Bonn", flag: "🇩🇪",
    city: "Bonn, NRW", founded: 1818, qsRank: "#201 QS World 2025",
    heroImg: "https://images.unsplash.com/photo-1467269204594-9661b134dd2b?q=80&w=1600&auto=format&fit=crop",
    campusImg: "https://images.unsplash.com/photo-1541339907198-e08756dedf3f?q=80&w=900&auto=format&fit=crop",
    overview: "Former capital of West Germany. Known for mathematics, economics, and political science. Six Nobel laureates among recent faculty. Home to numerous UN agencies and international organisations.",
    tuition: { domestic: "€0", international: "€0" },
    living: "€700–€1,000/mo", ielts: "6.0+", gre: "Program-dependent",
    topCourses: [
      { name: "M.Sc. Mathematics", duration: "2 years", language: "English" },
      { name: "M.Sc. Computer Science", duration: "2 years", language: "English" },
      { name: "M.Sc. Agricultural Sciences", duration: "2 years", language: "English" },
    ],
    placementStats: { rate: "88%", avgSalary: "€46,000–€63,000", topEmployers: ["UN Bonn", "Deutsche Post", "DHL", "Postbank", "IZA Institute"] },
    intakes: ["October (Winter Semester)"], istpStudents: 5,
  },

  "uni-freiburg": {
    slug: "uni-freiburg", country: "germany",
    name: "University of Freiburg", shortName: "Uni Freiburg", flag: "🇩🇪",
    city: "Freiburg, Baden-Württemberg", founded: 1457, qsRank: "#196 QS World 2025",
    heroImg: "https://images.unsplash.com/photo-1467269204594-9661b134dd2b?q=80&w=1600&auto=format&fit=crop",
    campusImg: "https://images.unsplash.com/photo-1541339907198-e08756dedf3f?q=80&w=900&auto=format&fit=crop",
    overview: "A picturesque university in the Black Forest region. Renowned for biology, medicine, and sustainability sciences. Close to France and Switzerland — perfect for trilingual career development.",
    tuition: { domestic: "€0", international: "€1,500/semester (non-EU)" },
    living: "€700–€1,000/mo", ielts: "6.0+", gre: "Not required",
    topCourses: [
      { name: "M.Sc. Environmental Sciences", duration: "2 years", language: "English" },
      { name: "M.Sc. Microsystems Engineering", duration: "2 years", language: "English" },
      { name: "M.Sc. Molecular Medicine", duration: "2 years", language: "English" },
    ],
    placementStats: { rate: "87%", avgSalary: "€46,000–€62,000", topEmployers: ["Roche Diagnostics", "Sick AG", "Endress+Hauser", "Festo", "BioNTech"] },
    intakes: ["October (Winter Semester)"], istpStudents: 4,
  },

  "uni-tubingen": {
    slug: "uni-tubingen", country: "germany",
    name: "University of Tübingen", shortName: "Uni Tübingen", flag: "🇩🇪",
    city: "Tübingen, Baden-Württemberg", founded: 1477, qsRank: "#165 QS World 2025",
    heroImg: "https://images.unsplash.com/photo-1467269204594-9661b134dd2b?q=80&w=1600&auto=format&fit=crop",
    campusImg: "https://images.unsplash.com/photo-1541339907198-e08756dedf3f?q=80&w=900&auto=format&fit=crop",
    overview: "A classic German university town. World-leading in neuroscience, machine learning, and computational biology. Home to major Max Planck institutes. A hub for AI research in Europe.",
    tuition: { domestic: "€0", international: "€0" },
    living: "€700–€1,000/mo", ielts: "6.5+", gre: "Program-dependent",
    topCourses: [
      { name: "M.Sc. Neural Information Processing", duration: "2 years", language: "English" },
      { name: "M.Sc. Machine Learning", duration: "2 years", language: "English" },
      { name: "M.Sc. Bioinformatics & Systems Biology", duration: "2 years", language: "English" },
    ],
    placementStats: { rate: "91%", avgSalary: "€50,000–€68,000", topEmployers: ["Amazon", "Bosch AI", "Max Planck", "Zeiss", "DeepMind"] },
    intakes: ["October (Winter Semester)"], istpStudents: 6,
  },

  "uni-erlangen": {
    slug: "uni-erlangen", country: "germany",
    name: "Friedrich-Alexander University Erlangen-Nuremberg", shortName: "FAU Erlangen", flag: "🇩🇪",
    city: "Erlangen / Nuremberg, Bavaria", founded: 1743, qsRank: "#271 QS World 2025",
    heroImg: "https://images.unsplash.com/photo-1467269204594-9661b134dd2b?q=80&w=1600&auto=format&fit=crop",
    campusImg: "https://images.unsplash.com/photo-1541339907198-e08756dedf3f?q=80&w=900&auto=format&fit=crop",
    overview: "Bavaria's second-largest university. Excellent for engineering, medical engineering, and computer science. Strong ties to Siemens Healthineers and the medical tech sector.",
    tuition: { domestic: "€0", international: "€0" },
    living: "€700–€1,000/mo", ielts: "6.0+", gre: "Not required",
    topCourses: [
      { name: "M.Sc. Medical Engineering", duration: "2 years", language: "English" },
      { name: "M.Sc. Advanced Signal Processing", duration: "2 years", language: "English" },
      { name: "M.Sc. International Business Studies", duration: "2 years", language: "English" },
    ],
    placementStats: { rate: "92%", avgSalary: "€51,000–€69,000", topEmployers: ["Siemens Healthineers", "Adidas", "Schaeffler", "Diehl", "GfK"] },
    intakes: ["October (Winter Semester)"], istpStudents: 8,
  },

  "tu-darmstadt": {
    slug: "tu-darmstadt", country: "germany",
    name: "TU Darmstadt", shortName: "TU Darmstadt", flag: "🇩🇪",
    city: "Darmstadt, Hesse", founded: 1877, qsRank: "#290 QS World 2025",
    heroImg: "https://images.unsplash.com/photo-1467269204594-9661b134dd2b?q=80&w=1600&auto=format&fit=crop",
    campusImg: "https://images.unsplash.com/photo-1541339907198-e08756dedf3f?q=80&w=900&auto=format&fit=crop",
    overview: "Germany's autonomous technical university. Known for computer science, electrical engineering, and cybersecurity. Located 30 minutes from Frankfurt with strong fintech industry links.",
    tuition: { domestic: "€0", international: "€0" },
    living: "€750–€1,050/mo", ielts: "6.0+", gre: "Not required",
    topCourses: [
      { name: "M.Sc. Computer Science", duration: "2 years", language: "English" },
      { name: "M.Sc. IT-Security", duration: "2 years", language: "English" },
      { name: "M.Sc. Electrical Engineering & Information Technology", duration: "2 years", language: "English" },
    ],
    placementStats: { rate: "93%", avgSalary: "€52,000–€70,000", topEmployers: ["Software AG", "IBM", "Merck KGaA", "T-Systems", "Continental"] },
    intakes: ["October (Winter Semester)"], istpStudents: 9,
  },

  "uni-munster": {
    slug: "uni-munster", country: "germany",
    name: "University of Münster", shortName: "Uni Münster", flag: "🇩🇪",
    city: "Münster, NRW", founded: 1780, qsRank: "#272 QS World 2025",
    heroImg: "https://images.unsplash.com/photo-1467269204594-9661b134dd2b?q=80&w=1600&auto=format&fit=crop",
    campusImg: "https://images.unsplash.com/photo-1541339907198-e08756dedf3f?q=80&w=900&auto=format&fit=crop",
    overview: "Germany's most bike-friendly university city with 50,000+ students. Particularly strong in law, chemistry, and economics. Excellent student quality of life at low cost.",
    tuition: { domestic: "€0", international: "€0" },
    living: "€700–€950/mo", ielts: "6.0+", gre: "Not required",
    topCourses: [
      { name: "M.Sc. Chemistry", duration: "2 years", language: "English/German" },
      { name: "M.Sc. Mathematics", duration: "2 years", language: "English" },
      { name: "LLM — International Law", duration: "1 year", language: "English" },
    ],
    placementStats: { rate: "87%", avgSalary: "€46,000–€62,000", topEmployers: ["Westfalen AG", "LANXESS", "Wolters Kluwer", "LVM Insurance", "Evonik"] },
    intakes: ["October (Winter Semester)"], istpStudents: 5,
  },

  "uni-bochum": {
    slug: "uni-bochum", country: "germany",
    name: "Ruhr University Bochum", shortName: "RUB", flag: "🇩🇪",
    city: "Bochum, NRW", founded: 1962, qsRank: "#299 QS World 2025",
    heroImg: "https://images.unsplash.com/photo-1467269204594-9661b134dd2b?q=80&w=1600&auto=format&fit=crop",
    campusImg: "https://images.unsplash.com/photo-1541339907198-e08756dedf3f?q=80&w=900&auto=format&fit=crop",
    overview: "The first new university established in postwar Germany. Strong in engineering, IT security, and materials science in the heart of Germany's Ruhr industrial belt.",
    tuition: { domestic: "€0", international: "€0" },
    living: "€650–€900/mo", ielts: "6.0+", gre: "Not required",
    topCourses: [
      { name: "M.Sc. IT-Security", duration: "2 years", language: "English" },
      { name: "M.Sc. Electrical Engineering", duration: "2 years", language: "English" },
      { name: "M.Sc. Mechanical Engineering", duration: "2 years", language: "English" },
    ],
    placementStats: { rate: "88%", avgSalary: "€47,000–€63,000", topEmployers: ["ThyssenKrupp", "Evonik", "E.ON", "RWE", "TÜV Nord"] },
    intakes: ["October (Winter Semester)"], istpStudents: 5,
  },

  "tu-braunschweig": {
    slug: "tu-braunschweig", country: "germany",
    name: "TU Braunschweig", shortName: "TU Braunschweig", flag: "🇩🇪",
    city: "Braunschweig, Lower Saxony", founded: 1745, qsRank: "#601 QS World 2025",
    heroImg: "https://images.unsplash.com/photo-1467269204594-9661b134dd2b?q=80&w=1600&auto=format&fit=crop",
    campusImg: "https://images.unsplash.com/photo-1541339907198-e08756dedf3f?q=80&w=900&auto=format&fit=crop",
    overview: "Germany's oldest technical university. Strong in aerospace, automotive, and information technology engineering. Close proximity to Volkswagen headquarters in Wolfsburg.",
    tuition: { domestic: "€0", international: "€0" },
    living: "€650–€900/mo", ielts: "6.0+", gre: "Not required",
    topCourses: [
      { name: "M.Sc. Aerospace Engineering", duration: "2 years", language: "English" },
      { name: "M.Sc. Automotive Engineering", duration: "2 years", language: "English" },
      { name: "M.Sc. Computer Science", duration: "2 years", language: "English" },
    ],
    placementStats: { rate: "90%", avgSalary: "€48,000–€65,000", topEmployers: ["Volkswagen", "Lufthansa Technik", "Siemens", "MAN", "Continental"] },
    intakes: ["October (Winter Semester)"], istpStudents: 4,
  },

  "uni-jena": {
    slug: "uni-jena", country: "germany",
    name: "Friedrich Schiller University Jena", shortName: "Uni Jena", flag: "🇩🇪",
    city: "Jena, Thuringia", founded: 1558, qsRank: "#401 QS World 2025",
    heroImg: "https://images.unsplash.com/photo-1467269204594-9661b134dd2b?q=80&w=1600&auto=format&fit=crop",
    campusImg: "https://images.unsplash.com/photo-1541339907198-e08756dedf3f?q=80&w=900&auto=format&fit=crop",
    overview: "Home of Carl Zeiss, Schott, and Jenoptik — Jena is Germany's optics and photonics capital. World-class programmes in optics, photonics, and materials science.",
    tuition: { domestic: "€0", international: "€0" },
    living: "€600–€850/mo", ielts: "6.0+", gre: "Not required",
    topCourses: [
      { name: "M.Sc. Photonics", duration: "2 years", language: "English" },
      { name: "M.Sc. Optical Engineering", duration: "2 years", language: "English" },
      { name: "M.Sc. Materials Science", duration: "2 years", language: "English" },
    ],
    placementStats: { rate: "87%", avgSalary: "€46,000–€61,000", topEmployers: ["Carl Zeiss", "Jenoptik", "Schott AG", "Analytik Jena", "Leica"] },
    intakes: ["October (Winter Semester)"], istpStudents: 3,
  },

  "uni-mainz": {
    slug: "uni-mainz", country: "germany",
    name: "Johannes Gutenberg University Mainz", shortName: "JGU Mainz", flag: "🇩🇪",
    city: "Mainz, Rhineland-Palatinate", founded: 1477, qsRank: "#301 QS World 2025",
    heroImg: "https://images.unsplash.com/photo-1467269204594-9661b134dd2b?q=80&w=1600&auto=format&fit=crop",
    campusImg: "https://images.unsplash.com/photo-1541339907198-e08756dedf3f?q=80&w=900&auto=format&fit=crop",
    overview: "Named after the inventor of the printing press. Home city of BioNTech. Strong in chemistry, pharmacy, and translational medicine. Close to Frankfurt's financial district.",
    tuition: { domestic: "€0", international: "€0" },
    living: "€700–€1,000/mo", ielts: "6.0+", gre: "Program-dependent",
    topCourses: [
      { name: "M.Sc. Pharmaceutical Biotechnology", duration: "2 years", language: "English" },
      { name: "M.Sc. Clinical Research", duration: "2 years", language: "English" },
      { name: "M.Sc. Chemistry", duration: "2 years", language: "English/German" },
    ],
    placementStats: { rate: "88%", avgSalary: "€47,000–€63,000", topEmployers: ["BioNTech", "Boehringer Ingelheim", "BASF", "Abbott", "AbbVie"] },
    intakes: ["October (Winter Semester)"], istpStudents: 4,
  },

  "uni-kiel": {
    slug: "uni-kiel", country: "germany",
    name: "Kiel University (CAU)", shortName: "Uni Kiel", flag: "🇩🇪",
    city: "Kiel, Schleswig-Holstein", founded: 1665, qsRank: "#401 QS World 2025",
    heroImg: "https://images.unsplash.com/photo-1467269204594-9661b134dd2b?q=80&w=1600&auto=format&fit=crop",
    campusImg: "https://images.unsplash.com/photo-1541339907198-e08756dedf3f?q=80&w=900&auto=format&fit=crop",
    overview: "Germany's gateway to Scandinavia. World-leading in marine science, oceanography, and sustainability. Hosts the GEOMAR Helmholtz Ocean Research Centre.",
    tuition: { domestic: "€0", international: "€0" },
    living: "€700–€950/mo", ielts: "6.0+", gre: "Not required",
    topCourses: [
      { name: "M.Sc. Ocean and Climate Physics", duration: "2 years", language: "English" },
      { name: "M.Sc. Marine Geosciences", duration: "2 years", language: "English" },
      { name: "M.Sc. Computational Life Science", duration: "2 years", language: "English" },
    ],
    placementStats: { rate: "86%", avgSalary: "€45,000–€61,000", topEmployers: ["GEOMAR", "Siemens Wind Power", "ThyssenKrupp Marine", "HDW Shipyards"] },
    intakes: ["October (Winter Semester)"], istpStudents: 3,
  },

  "uni-halle": {
    slug: "uni-halle", country: "germany",
    name: "Martin Luther University Halle-Wittenberg", shortName: "MLU Halle", flag: "🇩🇪",
    city: "Halle, Saxony-Anhalt", founded: 1694, qsRank: "#601 QS World 2025",
    heroImg: "https://images.unsplash.com/photo-1467269204594-9661b134dd2b?q=80&w=1600&auto=format&fit=crop",
    campusImg: "https://images.unsplash.com/photo-1541339907198-e08756dedf3f?q=80&w=900&auto=format&fit=crop",
    overview: "Germany's historic Reformation university. Strong in agricultural biotechnology, pharmacy, and materials chemistry. Very affordable city with low cost of living.",
    tuition: { domestic: "€0", international: "€0" },
    living: "€550–€800/mo", ielts: "6.0+", gre: "Not required",
    topCourses: [
      { name: "M.Sc. Plant Biotechnology", duration: "2 years", language: "English" },
      { name: "M.Sc. Pharmaceutical Chemistry", duration: "2 years", language: "English" },
      { name: "M.Sc. Organic Chemistry", duration: "2 years", language: "English" },
    ],
    placementStats: { rate: "85%", avgSalary: "€44,000–€58,000", topEmployers: ["Bayer Crop Science", "Südzucker", "Dow AgroSciences", "BASF", "Nufarm"] },
    intakes: ["October (Winter Semester)"], istpStudents: 3,
  },

  "uni-potsdam": {
    slug: "uni-potsdam", country: "germany",
    name: "University of Potsdam", shortName: "Uni Potsdam", flag: "🇩🇪",
    city: "Potsdam, Brandenburg", founded: 1991, qsRank: "#601 QS World 2025",
    heroImg: "https://images.unsplash.com/photo-1467269204594-9661b134dd2b?q=80&w=1600&auto=format&fit=crop",
    campusImg: "https://images.unsplash.com/photo-1541339907198-e08756dedf3f?q=80&w=900&auto=format&fit=crop",
    overview: "Set among Prussian palaces near Berlin. Strong in cognitive science, computer linguistics, and geosciences. Easy Berlin access with a lower cost of living.",
    tuition: { domestic: "€0", international: "€0" },
    living: "€750–€1,000/mo", ielts: "6.0+", gre: "Not required",
    topCourses: [
      { name: "M.Sc. Cognitive Systems", duration: "2 years", language: "English" },
      { name: "M.Sc. Data Science", duration: "2 years", language: "English" },
      { name: "M.Sc. Geosciences", duration: "2 years", language: "English" },
    ],
    placementStats: { rate: "87%", avgSalary: "€47,000–€63,000", topEmployers: ["Hasso Plattner Institute", "SAP", "GFZ Research", "Zalando", "Bundesministerium"] },
    intakes: ["October (Winter Semester)"], istpStudents: 4,
  },

  "uni-ulm": {
    slug: "uni-ulm", country: "germany",
    name: "Ulm University", shortName: "Uni Ulm", flag: "🇩🇪",
    city: "Ulm, Baden-Württemberg", founded: 1967, qsRank: "#401 QS World 2025",
    heroImg: "https://images.unsplash.com/photo-1467269204594-9661b134dd2b?q=80&w=1600&auto=format&fit=crop",
    campusImg: "https://images.unsplash.com/photo-1541339907198-e08756dedf3f?q=80&w=900&auto=format&fit=crop",
    overview: "Birthplace of Albert Einstein. Ranked among Germany's top young universities. Strong in neuroscience, quantum technology, and bioinformatics. Excellent for battery and energy research.",
    tuition: { domestic: "€0", international: "€0" },
    living: "€650–€950/mo", ielts: "6.5+", gre: "Program-dependent",
    topCourses: [
      { name: "M.Sc. Molecular Medicine", duration: "2 years", language: "English" },
      { name: "M.Sc. Advanced Materials", duration: "2 years", language: "English" },
      { name: "M.Sc. Communications Engineering", duration: "2 years", language: "English" },
    ],
    placementStats: { rate: "91%", avgSalary: "€50,000–€67,000", topEmployers: ["Daimler AG", "Iveco Magirus", "Wieland-Werke", "Husqvarna Group", "ZF Friedrichshafen"] },
    intakes: ["October (Winter Semester)"], istpStudents: 5,
  },

  "uni-konstanz": {
    slug: "uni-konstanz", country: "germany",
    name: "University of Konstanz", shortName: "Uni Konstanz", flag: "🇩🇪",
    city: "Konstanz, Baden-Württemberg", founded: 1966, qsRank: "#401 QS World 2025",
    heroImg: "https://images.unsplash.com/photo-1467269204594-9661b134dd2b?q=80&w=1600&auto=format&fit=crop",
    campusImg: "https://images.unsplash.com/photo-1541339907198-e08756dedf3f?q=80&w=900&auto=format&fit=crop",
    overview: "A compact excellence university on Lake Constance bordering Switzerland. Strong in political science, biology, and chemistry. Part of Germany's Excellence Initiative.",
    tuition: { domestic: "€0", international: "€0" },
    living: "€700–€1,050/mo", ielts: "6.5+", gre: "Program-dependent",
    topCourses: [
      { name: "M.Sc. Data Science", duration: "2 years", language: "English" },
      { name: "M.Sc. Molecular Biology", duration: "2 years", language: "English" },
      { name: "M.A. Political Science & Public Administration", duration: "2 years", language: "English" },
    ],
    placementStats: { rate: "88%", avgSalary: "€47,000–€64,000", topEmployers: ["Google Switzerland", "Siemens", "Bosch", "ABB", "EKZ"] },
    intakes: ["October (Winter Semester)"], istpStudents: 4,
  },

  "uni-regensburg": {
    slug: "uni-regensburg", country: "germany",
    name: "University of Regensburg", shortName: "Uni Regensburg", flag: "🇩🇪",
    city: "Regensburg, Bavaria", founded: 1962, qsRank: "#701 QS World 2025",
    heroImg: "https://images.unsplash.com/photo-1467269204594-9661b134dd2b?q=80&w=1600&auto=format&fit=crop",
    campusImg: "https://images.unsplash.com/photo-1541339907198-e08756dedf3f?q=80&w=900&auto=format&fit=crop",
    overview: "A compact, well-equipped university in UNESCO World Heritage–listed Regensburg. Strong in biochemistry, law, and nanostructure technology. Very affordable Bavarian city.",
    tuition: { domestic: "€0", international: "€0" },
    living: "€650–€900/mo", ielts: "6.0+", gre: "Not required",
    topCourses: [
      { name: "M.Sc. Nanostructure Technology", duration: "2 years", language: "English" },
      { name: "M.Sc. Computational Science", duration: "2 years", language: "English" },
      { name: "M.Sc. Biochemistry", duration: "2 years", language: "English/German" },
    ],
    placementStats: { rate: "86%", avgSalary: "€44,000–€60,000", topEmployers: ["Infineon Technologies", "BMW", "Continental", "KRONES AG", "Siemens"] },
    intakes: ["October (Winter Semester)"], istpStudents: 3,
  },

  "uni-augsburg": {
    slug: "uni-augsburg", country: "germany",
    name: "University of Augsburg", shortName: "Uni Augsburg", flag: "🇩🇪",
    city: "Augsburg, Bavaria", founded: 1970, qsRank: "#701 QS World 2025",
    heroImg: "https://images.unsplash.com/photo-1467269204594-9661b134dd2b?q=80&w=1600&auto=format&fit=crop",
    campusImg: "https://images.unsplash.com/photo-1541339907198-e08756dedf3f?q=80&w=900&auto=format&fit=crop",
    overview: "A dynamic Bavarian university near Munich with strong focus on applied sciences, business, and resource efficiency. Lower living costs than Munich with similar industry access.",
    tuition: { domestic: "€0", international: "€0" },
    living: "€650–€900/mo", ielts: "6.0+", gre: "Not required",
    topCourses: [
      { name: "M.Sc. Resource Efficiency Management", duration: "2 years", language: "English" },
      { name: "M.Sc. Materials Science", duration: "2 years", language: "English" },
      { name: "M.Sc. Business Administration", duration: "2 years", language: "English" },
    ],
    placementStats: { rate: "87%", avgSalary: "€46,000–€62,000", topEmployers: ["MAN Energy Solutions", "Osram", "Renk Group", "Patrizia", "SGL Carbon"] },
    intakes: ["October (Winter Semester)"], istpStudents: 4,
  },

  "uni-bayreuth": {
    slug: "uni-bayreuth", country: "germany",
    name: "University of Bayreuth", shortName: "Uni Bayreuth", flag: "🇩🇪",
    city: "Bayreuth, Bavaria", founded: 1975, qsRank: "#601 QS World 2025",
    heroImg: "https://images.unsplash.com/photo-1467269204594-9661b134dd2b?q=80&w=1600&auto=format&fit=crop",
    campusImg: "https://images.unsplash.com/photo-1541339907198-e08756dedf3f?q=80&w=900&auto=format&fit=crop",
    overview: "Innovative interdisciplinary programmes. Germany's #1 for African Studies. Strong in polymer science, sports economics, and food science.",
    tuition: { domestic: "€0", international: "€0" },
    living: "€600–€850/mo", ielts: "6.0+", gre: "Not required",
    topCourses: [
      { name: "M.Sc. Polymer & Colloid Science", duration: "2 years", language: "English" },
      { name: "M.Sc. African Development Studies", duration: "2 years", language: "English" },
      { name: "M.Sc. Sport Science & Management", duration: "2 years", language: "English" },
    ],
    placementStats: { rate: "85%", avgSalary: "€44,000–€58,000", topEmployers: ["Lohmann & Rauscher", "Rehau", "Grammer", "Allianz", "MAN"] },
    intakes: ["October (Winter Semester)"], istpStudents: 3,
  },

  "uni-rostock": {
    slug: "uni-rostock", country: "germany",
    name: "University of Rostock", shortName: "Uni Rostock", flag: "🇩🇪",
    city: "Rostock, Mecklenburg-Vorpommern", founded: 1419, qsRank: "#801 QS World 2025",
    heroImg: "https://images.unsplash.com/photo-1467269204594-9661b134dd2b?q=80&w=1600&auto=format&fit=crop",
    campusImg: "https://images.unsplash.com/photo-1541339907198-e08756dedf3f?q=80&w=900&auto=format&fit=crop",
    overview: "One of Germany's oldest universities on the Baltic Sea. Strong in maritime technology, life sciences, and electrical engineering. Very low living costs.",
    tuition: { domestic: "€0", international: "€0" },
    living: "€550–€800/mo", ielts: "6.0+", gre: "Not required",
    topCourses: [
      { name: "M.Sc. Maritime Technologies", duration: "2 years", language: "English" },
      { name: "M.Sc. Electrical Engineering", duration: "2 years", language: "English" },
      { name: "M.Sc. Medical Biotechnology", duration: "2 years", language: "English" },
    ],
    placementStats: { rate: "85%", avgSalary: "€43,000–€57,000", topEmployers: ["Neptun Werft", "Liebherr", "Rolls-Royce Power Systems", "Nordex", "bioMérieux"] },
    intakes: ["October (Winter Semester)"], istpStudents: 2,
  },

  "uni-paderborn": {
    slug: "uni-paderborn", country: "germany",
    name: "University of Paderborn", shortName: "Uni Paderborn", flag: "🇩🇪",
    city: "Paderborn, NRW", founded: 1972, qsRank: "#801 QS World 2025",
    heroImg: "https://images.unsplash.com/photo-1467269204594-9661b134dd2b?q=80&w=1600&auto=format&fit=crop",
    campusImg: "https://images.unsplash.com/photo-1541339907198-e08756dedf3f?q=80&w=900&auto=format&fit=crop",
    overview: "Known as Germany's University of Information Technology. Strong in computer science, electrical engineering, and business IT. Close ties to Benteler, Miele, and Claas.",
    tuition: { domestic: "€0", international: "€0" },
    living: "€650–€900/mo", ielts: "6.0+", gre: "Not required",
    topCourses: [
      { name: "M.Sc. Computer Science", duration: "2 years", language: "English" },
      { name: "M.Sc. Electrical Engineering", duration: "2 years", language: "English" },
      { name: "M.Sc. Business Information Systems", duration: "2 years", language: "English" },
    ],
    placementStats: { rate: "88%", avgSalary: "€47,000–€63,000", topEmployers: ["Benteler", "Miele", "Claas", "Wincor Nixdorf", "Diebold Nixdorf"] },
    intakes: ["October (Winter Semester)"], istpStudents: 4,
  },

  "uni-bielefeld": {
    slug: "uni-bielefeld", country: "germany",
    name: "Bielefeld University", shortName: "Uni Bielefeld", flag: "🇩🇪",
    city: "Bielefeld, NRW", founded: 1969, qsRank: "#601 QS World 2025",
    heroImg: "https://images.unsplash.com/photo-1467269204594-9661b134dd2b?q=80&w=1600&auto=format&fit=crop",
    campusImg: "https://images.unsplash.com/photo-1541339907198-e08756dedf3f?q=80&w=900&auto=format&fit=crop",
    overview: "A research-focused university in a single iconic building. Strong in bioinformatics, cognitive science, and public health. One of Germany's most international campuses.",
    tuition: { domestic: "€0", international: "€0" },
    living: "€650–€900/mo", ielts: "6.0+", gre: "Not required",
    topCourses: [
      { name: "M.Sc. Bioinformatics & Genome Research", duration: "2 years", language: "English" },
      { name: "M.Sc. Intelligent Systems", duration: "2 years", language: "English" },
      { name: "M.A. Public Health", duration: "2 years", language: "English" },
    ],
    placementStats: { rate: "86%", avgSalary: "€45,000–€61,000", topEmployers: ["Bertelsmann", "Dr. Oetker", "Miele", "Gerry Weber", "Sievert Group"] },
    intakes: ["October (Winter Semester)"], istpStudents: 3,
  },

  "uni-dusseldorf": {
    slug: "uni-dusseldorf", country: "germany",
    name: "Heinrich Heine University Düsseldorf", shortName: "HHU Düsseldorf", flag: "🇩🇪",
    city: "Düsseldorf, NRW", founded: 1965, qsRank: "#601 QS World 2025",
    heroImg: "https://images.unsplash.com/photo-1467269204594-9661b134dd2b?q=80&w=1600&auto=format&fit=crop",
    campusImg: "https://images.unsplash.com/photo-1541339907198-e08756dedf3f?q=80&w=900&auto=format&fit=crop",
    overview: "Located in Germany's fashion and advertising capital. Strong in medicine, chemistry, and pharmaceutics with close ties to the pharma industry cluster around Düsseldorf.",
    tuition: { domestic: "€0", international: "€0" },
    living: "€750–€1,100/mo", ielts: "6.0+", gre: "Not required",
    topCourses: [
      { name: "M.Sc. Biotechnology", duration: "2 years", language: "English" },
      { name: "M.Sc. Pharmaceutical Sciences", duration: "2 years", language: "English" },
      { name: "M.Sc. Global Health", duration: "2 years", language: "English" },
    ],
    placementStats: { rate: "88%", avgSalary: "€48,000–€65,000", topEmployers: ["Henkel", "METRO AG", "Vodafone Germany", "Evonik", "Takeda Pharma"] },
    intakes: ["October (Winter Semester)"], istpStudents: 4,
  },

  "uni-saarland": {
    slug: "uni-saarland", country: "germany",
    name: "Saarland University", shortName: "Uni Saarland", flag: "🇩🇪",
    city: "Saarbrücken, Saarland", founded: 1948, qsRank: "#601 QS World 2025",
    heroImg: "https://images.unsplash.com/photo-1467269204594-9661b134dd2b?q=80&w=1600&auto=format&fit=crop",
    campusImg: "https://images.unsplash.com/photo-1541339907198-e08756dedf3f?q=80&w=900&auto=format&fit=crop",
    overview: "Bordering France and Luxembourg, Saarland University is uniquely trilingual. World-renowned for computer science and AI — home to the Max Planck Institute for Software Systems.",
    tuition: { domestic: "€0", international: "€0" },
    living: "€650–€900/mo", ielts: "6.0+", gre: "Not required",
    topCourses: [
      { name: "M.Sc. Computer Science", duration: "2 years", language: "English" },
      { name: "M.Sc. Visual Computing", duration: "2 years", language: "English" },
      { name: "M.Sc. Bioinformatics", duration: "2 years", language: "English" },
    ],
    placementStats: { rate: "90%", avgSalary: "€49,000–€66,000", topEmployers: ["SAP", "Intel", "Microsoft Research", "DFKI", "Saarstahl"] },
    intakes: ["October (Winter Semester)"], istpStudents: 5,
  },

  "uni-kassel": {
    slug: "uni-kassel", country: "germany",
    name: "University of Kassel", shortName: "Uni Kassel", flag: "🇩🇪",
    city: "Kassel, Hesse", founded: 1970, qsRank: "#801 QS World 2025",
    heroImg: "https://images.unsplash.com/photo-1467269204594-9661b134dd2b?q=80&w=1600&auto=format&fit=crop",
    campusImg: "https://images.unsplash.com/photo-1541339907198-e08756dedf3f?q=80&w=900&auto=format&fit=crop",
    overview: "Known for renewable energy, environmental engineering, and organic agriculture. Strong sustainability focus with ties to Germany's wind and solar industry.",
    tuition: { domestic: "€0", international: "€0" },
    living: "€600–€850/mo", ielts: "6.0+", gre: "Not required",
    topCourses: [
      { name: "M.Sc. Renewable Energy & Energy Efficiency", duration: "2 years", language: "English" },
      { name: "M.Sc. Organic Agricultural Sciences", duration: "2 years", language: "English" },
      { name: "M.Sc. International Development Studies", duration: "2 years", language: "English" },
    ],
    placementStats: { rate: "85%", avgSalary: "€44,000–€59,000", topEmployers: ["SMA Solar Technology", "Viessmann", "Fraunhofer IEE", "Enercon", "Deutsche Windtechnik"] },
    intakes: ["October (Winter Semester)"], istpStudents: 3,
  },

  "frankfurt-school": {
    slug: "frankfurt-school", country: "germany",
    name: "Frankfurt School of Finance & Management", shortName: "Frankfurt School", flag: "🇩🇪",
    city: "Frankfurt, Hesse", founded: 1957, qsRank: "#51 FT Global MBA 2024",
    heroImg: "https://images.unsplash.com/photo-1467269204594-9661b134dd2b?q=80&w=1600&auto=format&fit=crop",
    campusImg: "https://images.unsplash.com/photo-1541339907198-e08756dedf3f?q=80&w=900&auto=format&fit=crop",
    overview: "Germany's top private business school, steps from the ECB and Deutsche Bank. Globally ranked MBA with unrivalled access to European finance. Strong in fintech and sustainable finance.",
    tuition: { domestic: "€28,000/yr", international: "€28,000/yr" },
    living: "€1,000–€1,500/mo", ielts: "7.0+", gre: "Required",
    topCourses: [
      { name: "MBA — Full-Time", duration: "1 year", language: "English" },
      { name: "M.Sc. Finance", duration: "1.5 years", language: "English" },
      { name: "M.Sc. Digital Transformation & Fintech", duration: "1.5 years", language: "English" },
    ],
    placementStats: { rate: "96%", avgSalary: "€70,000–€110,000", topEmployers: ["Deutsche Bank", "ECB", "Goldman Sachs", "BCG", "BlackRock"] },
    intakes: ["September", "January"], istpStudents: 7,
  },

  "hhl-leipzig": {
    slug: "hhl-leipzig", country: "germany",
    name: "HHL Leipzig Graduate School of Management", shortName: "HHL Leipzig", flag: "🇩🇪",
    city: "Leipzig, Saxony", founded: 1898, qsRank: "#71 FT European Business Schools",
    heroImg: "https://images.unsplash.com/photo-1467269204594-9661b134dd2b?q=80&w=1600&auto=format&fit=crop",
    campusImg: "https://images.unsplash.com/photo-1541339907198-e08756dedf3f?q=80&w=900&auto=format&fit=crop",
    overview: "Germany's oldest private business school. Boutique MBA with a strong entrepreneurship and leadership focus. Consistently ranked top in Germany for entrepreneurship by the FT.",
    tuition: { domestic: "€25,000/yr", international: "€25,000/yr" },
    living: "€700–€1,000/mo", ielts: "6.5+", gre: "Required",
    topCourses: [
      { name: "MBA — Full-Time", duration: "1.5 years", language: "English" },
      { name: "M.Sc. Management", duration: "2 years", language: "English" },
      { name: "M.Sc. Innovation & Entrepreneurship", duration: "2 years", language: "English" },
    ],
    placementStats: { rate: "94%", avgSalary: "€62,000–€95,000", topEmployers: ["McKinsey", "Porsche", "Bain", "BMW", "Roland Berger"] },
    intakes: ["September", "January"], istpStudents: 5,
  },

  "mannheim-business": {
    slug: "mannheim-business", country: "germany",
    name: "University of Mannheim — Business School", shortName: "Mannheim Business", flag: "🇩🇪",
    city: "Mannheim, Baden-Württemberg", founded: 1907, qsRank: "#65 FT European Business Schools",
    heroImg: "https://images.unsplash.com/photo-1467269204594-9661b134dd2b?q=80&w=1600&auto=format&fit=crop",
    campusImg: "https://images.unsplash.com/photo-1541339907198-e08756dedf3f?q=80&w=900&auto=format&fit=crop",
    overview: "Germany's #1 public business school consistently ranked among Europe's best. Strong in accounting, finance, and management. Based in a baroque palace in the heart of the Rhine-Neckar tech region.",
    tuition: { domestic: "€0", international: "€0" },
    living: "€750–€1,050/mo", ielts: "6.5+", gre: "Required for MBA",
    topCourses: [
      { name: "M.Sc. Business Administration", duration: "2 years", language: "English" },
      { name: "M.Sc. Management Analytics", duration: "2 years", language: "English" },
      { name: "MBA — Mannheim Executive", duration: "1.5 years", language: "English" },
    ],
    placementStats: { rate: "95%", avgSalary: "€60,000–€90,000", topEmployers: ["BASF", "SAP", "McKinsey", "Deutsche Bank", "Deloitte"] },
    intakes: ["September"], istpStudents: 8,
  },

  "esmt-berlin": {
    slug: "esmt-berlin", country: "germany",
    name: "ESMT Berlin", shortName: "ESMT Berlin", flag: "🇩🇪",
    city: "Berlin", founded: 2002, qsRank: "#46 FT Global MBA 2024",
    heroImg: "https://images.unsplash.com/photo-1467269204594-9661b134dd2b?q=80&w=1600&auto=format&fit=crop",
    campusImg: "https://images.unsplash.com/photo-1541339907198-e08756dedf3f?q=80&w=900&auto=format&fit=crop",
    overview: "Germany's top business school by the FT MBA ranking. Founded by 25 global corporations including Bayer, Siemens, and Deutsche Bank. Located in a UNESCO-listed palace in central Berlin.",
    tuition: { domestic: "€35,000/total", international: "€35,000/total" },
    living: "€900–€1,300/mo", ielts: "7.0+", gre: "Required",
    topCourses: [
      { name: "Full-Time MBA", duration: "1 year", language: "English" },
      { name: "M.Sc. Management", duration: "1.5 years", language: "English" },
      { name: "M.Sc. Innovation & Entrepreneurship", duration: "1 year", language: "English" },
    ],
    placementStats: { rate: "96%", avgSalary: "€72,000–€115,000", topEmployers: ["Siemens", "Bayer", "BCG", "Amazon", "Deutsche Telekom"] },
    intakes: ["September", "January"], istpStudents: 6,
  },

  "tu-clausthal": {
    slug: "tu-clausthal", country: "germany",
    name: "Clausthal University of Technology", shortName: "TU Clausthal", flag: "🇩🇪",
    city: "Clausthal-Zellerfeld, Lower Saxony", founded: 1775, qsRank: "#801 QS World 2025",
    heroImg: "https://images.unsplash.com/photo-1467269204594-9661b134dd2b?q=80&w=1600&auto=format&fit=crop",
    campusImg: "https://images.unsplash.com/photo-1541339907198-e08756dedf3f?q=80&w=900&auto=format&fit=crop",
    overview: "A specialised technical university in the Harz Mountains. Extremely small cohorts — excellent professor access. Strong in energy systems, process engineering, and mining technology.",
    tuition: { domestic: "€0", international: "€0" },
    living: "€500–€750/mo", ielts: "6.0+", gre: "Not required",
    topCourses: [
      { name: "M.Sc. Energy Systems & Technology", duration: "2 years", language: "English" },
      { name: "M.Sc. Materials Science & Engineering", duration: "2 years", language: "English" },
      { name: "M.Sc. Computer Science", duration: "2 years", language: "English" },
    ],
    placementStats: { rate: "87%", avgSalary: "€46,000–€62,000", topEmployers: ["Salzgitter AG", "TÜV Nord", "E.ON", "RWE", "K+S AG"] },
    intakes: ["October (Winter Semester)"], istpStudents: 3,
  },

  "uni-bremen": {
    slug: "uni-bremen", country: "germany",
    name: "University of Bremen", shortName: "Uni Bremen", flag: "🇩🇪",
    city: "Bremen", founded: 1971, qsRank: "#401 QS World 2025",
    heroImg: "https://images.unsplash.com/photo-1467269204594-9661b134dd2b?q=80&w=1600&auto=format&fit=crop",
    campusImg: "https://images.unsplash.com/photo-1541339907198-e08756dedf3f?q=80&w=900&auto=format&fit=crop",
    overview: "An excellence university in Germany's maritime hub. Strong in cognitive neuroscience, space technology, and logistics management. Home to Airbus's largest European production site.",
    tuition: { domestic: "€0", international: "€0" },
    living: "€700–€1,000/mo", ielts: "6.0+", gre: "Not required",
    topCourses: [
      { name: "M.Sc. Space Engineering", duration: "2 years", language: "English" },
      { name: "M.Sc. Global Political Economy", duration: "2 years", language: "English" },
      { name: "M.Sc. Cognitive Neuroscience", duration: "2 years", language: "English" },
    ],
    placementStats: { rate: "88%", avgSalary: "€47,000–€63,000", topEmployers: ["Airbus", "OHB System", "Daimler", "Nordmende", "BLG Logistics"] },
    intakes: ["October (Winter Semester)"], istpStudents: 4,
  },

  "jacobs-university": {
    slug: "jacobs-university", country: "germany",
    name: "Constructor University Bremen", shortName: "Constructor Uni", flag: "🇩🇪",
    city: "Bremen", founded: 2001, qsRank: "#501 QS World 2025",
    heroImg: "https://images.unsplash.com/photo-1467269204594-9661b134dd2b?q=80&w=1600&auto=format&fit=crop",
    campusImg: "https://images.unsplash.com/photo-1541339907198-e08756dedf3f?q=80&w=900&auto=format&fit=crop",
    overview: "Germany's top private international residential campus university. 110+ nationalities, fully English-taught, strong in STEM and social sciences. American-style college experience in Germany.",
    tuition: { domestic: "€20,000/yr", international: "€20,000/yr" },
    living: "€800–€1,200/mo (incl. room)", ielts: "6.5+", gre: "Required",
    topCourses: [
      { name: "M.Sc. Data Engineering", duration: "2 years", language: "English" },
      { name: "M.Sc. Electrical Engineering", duration: "2 years", language: "English" },
      { name: "M.Sc. Global Economics & Management", duration: "2 years", language: "English" },
    ],
    placementStats: { rate: "92%", avgSalary: "€52,000–€72,000", topEmployers: ["Google", "Amazon", "Deloitte", "McKinsey", "Deutsche Telekom"] },
    intakes: ["September"], istpStudents: 6,
  },

  "uni-wurzburg": {
    slug: "uni-wurzburg", country: "germany",
    name: "University of Würzburg", shortName: "Uni Würzburg", flag: "🇩🇪",
    city: "Würzburg, Bavaria", founded: 1402, qsRank: "#371 QS World 2025",
    heroImg: "https://images.unsplash.com/photo-1467269204594-9661b134dd2b?q=80&w=1600&auto=format&fit=crop",
    campusImg: "https://images.unsplash.com/photo-1541339907198-e08756dedf3f?q=80&w=900&auto=format&fit=crop",
    overview: "Wilhelm Röntgen discovered X-rays here. Known for satellite communications, physics, and biomedicine. Scenic Baroque city with excellent student life and very affordable living.",
    tuition: { domestic: "€0", international: "€0" },
    living: "€650–€950/mo", ielts: "6.0+", gre: "Not required",
    topCourses: [
      { name: "M.Sc. Aerospace Information Technology", duration: "2 years", language: "English" },
      { name: "M.Sc. Computational Mathematics", duration: "2 years", language: "English" },
      { name: "M.Sc. Biofabrication", duration: "2 years", language: "English" },
    ],
    placementStats: { rate: "88%", avgSalary: "€46,000–€62,000", topEmployers: ["Würth Group", "BSH Hausgeräte", "ZF Friedrichshafen", "Bosch", "Brose"] },
    intakes: ["October (Winter Semester)"], istpStudents: 4,
  },

  "uni-giessen": {
    slug: "uni-giessen", country: "germany",
    name: "Justus Liebig University Giessen", shortName: "JLU Giessen", flag: "🇩🇪",
    city: "Giessen, Hesse", founded: 1607, qsRank: "#601 QS World 2025",
    heroImg: "https://images.unsplash.com/photo-1467269204594-9661b134dd2b?q=80&w=1600&auto=format&fit=crop",
    campusImg: "https://images.unsplash.com/photo-1541339907198-e08756dedf3f?q=80&w=900&auto=format&fit=crop",
    overview: "Named after chemist Justus von Liebig, a pioneer of organic chemistry. Strong in life sciences, veterinary medicine, and nutritional sciences. Close to Frankfurt.",
    tuition: { domestic: "€0", international: "€0" },
    living: "€650–€900/mo", ielts: "6.0+", gre: "Not required",
    topCourses: [
      { name: "M.Sc. Life Sciences", duration: "2 years", language: "English" },
      { name: "M.Sc. Nutritional Sciences", duration: "2 years", language: "English" },
      { name: "M.Sc. Infection Biology", duration: "2 years", language: "English" },
    ],
    placementStats: { rate: "86%", avgSalary: "€44,000–€60,000", topEmployers: ["Boehringer Ingelheim", "B. Braun", "Merck", "Pfizer", "Sanofi"] },
    intakes: ["October (Winter Semester)"], istpStudents: 3,
  },

  "uni-marburg": {
    slug: "uni-marburg", country: "germany",
    name: "Philipps University Marburg", shortName: "Uni Marburg", flag: "🇩🇪",
    city: "Marburg, Hesse", founded: 1527, qsRank: "#601 QS World 2025",
    heroImg: "https://images.unsplash.com/photo-1467269204594-9661b134dd2b?q=80&w=1600&auto=format&fit=crop",
    campusImg: "https://images.unsplash.com/photo-1541339907198-e08756dedf3f?q=80&w=900&auto=format&fit=crop",
    overview: "The world's first Protestant university and Germany's first secular university. Charming medieval campus town. Excellent in chemistry, pharmacy, and social sciences.",
    tuition: { domestic: "€0", international: "€0" },
    living: "€600–€850/mo", ielts: "6.0+", gre: "Not required",
    topCourses: [
      { name: "M.Sc. Chemistry", duration: "2 years", language: "English/German" },
      { name: "M.Sc. Pharmacy", duration: "2 years", language: "German" },
      { name: "M.A. Conflict, Peace & Justice", duration: "2 years", language: "English" },
    ],
    placementStats: { rate: "85%", avgSalary: "€43,000–€58,000", topEmployers: ["CSL Behring", "B. Braun", "Fresenius", "Merck KGaA", "Siemens"] },
    intakes: ["October (Winter Semester)"], istpStudents: 2,
  },

  "tu-kaiserslautern": {
    slug: "tu-kaiserslautern", country: "germany",
    name: "RPTU Kaiserslautern-Landau", shortName: "RPTU KL", flag: "🇩🇪",
    city: "Kaiserslautern, Rhineland-Palatinate", founded: 1970, qsRank: "#801 QS World 2025",
    heroImg: "https://images.unsplash.com/photo-1467269204594-9661b134dd2b?q=80&w=1600&auto=format&fit=crop",
    campusImg: "https://images.unsplash.com/photo-1541339907198-e08756dedf3f?q=80&w=900&auto=format&fit=crop",
    overview: "Home of the German Research Centre for Artificial Intelligence (DFKI) — Europe's largest AI research institute. Strong in computer science, mathematics, and software engineering.",
    tuition: { domestic: "€0", international: "€0" },
    living: "€600–€850/mo", ielts: "6.0+", gre: "Not required",
    topCourses: [
      { name: "M.Sc. Computer Science", duration: "2 years", language: "English" },
      { name: "M.Sc. Mathematics", duration: "2 years", language: "English" },
      { name: "M.Sc. Mechatronics", duration: "2 years", language: "English" },
    ],
    placementStats: { rate: "89%", avgSalary: "€48,000–€64,000", topEmployers: ["DFKI", "SAP", "Bosch", "John Deere", "Siemens"] },
    intakes: ["October (Winter Semester)"], istpStudents: 4,
  },

  "uni-wuppertal": {
    slug: "uni-wuppertal", country: "germany",
    name: "University of Wuppertal", shortName: "Uni Wuppertal", flag: "🇩🇪",
    city: "Wuppertal, NRW", founded: 1972, qsRank: "#801 QS World 2025",
    heroImg: "https://images.unsplash.com/photo-1467269204594-9661b134dd2b?q=80&w=1600&auto=format&fit=crop",
    campusImg: "https://images.unsplash.com/photo-1541339907198-e08756dedf3f?q=80&w=900&auto=format&fit=crop",
    overview: "Located in the Bergisches Land near Cologne and Düsseldorf. Strong in electrical engineering, safety engineering, and mathematics. Very affordable with excellent metropolitan access.",
    tuition: { domestic: "€0", international: "€0" },
    living: "€650–€900/mo", ielts: "6.0+", gre: "Not required",
    topCourses: [
      { name: "M.Sc. Electrical Engineering", duration: "2 years", language: "English" },
      { name: "M.Sc. Safety Engineering", duration: "2 years", language: "English" },
      { name: "M.Sc. Mathematics", duration: "2 years", language: "English" },
    ],
    placementStats: { rate: "86%", avgSalary: "€45,000–€60,000", topEmployers: ["Bayer", "BASF", "Ford", "Voith", "TÜV Rheinland"] },
    intakes: ["October (Winter Semester)"], istpStudents: 3,
  },

  "fh-aachen": {
    slug: "fh-aachen", country: "germany",
    name: "FH Aachen University of Applied Sciences", shortName: "FH Aachen", flag: "🇩🇪",
    city: "Aachen, NRW", founded: 1971, qsRank: "Top UAS Germany",
    heroImg: "https://images.unsplash.com/photo-1467269204594-9661b134dd2b?q=80&w=1600&auto=format&fit=crop",
    campusImg: "https://images.unsplash.com/photo-1541339907198-e08756dedf3f?q=80&w=900&auto=format&fit=crop",
    overview: "One of Germany's largest universities of applied sciences. Particularly strong in aerospace technology, energy systems, and biomedical engineering. Industry-integrated practical curriculum.",
    tuition: { domestic: "€0", international: "€0" },
    living: "€750–€1,000/mo", ielts: "6.0+", gre: "Not required",
    topCourses: [
      { name: "M.Sc. Aerospace Engineering", duration: "1.5 years", language: "English" },
      { name: "M.Sc. Energy Systems", duration: "1.5 years", language: "English" },
      { name: "M.Sc. Biomedical Engineering", duration: "1.5 years", language: "English" },
    ],
    placementStats: { rate: "91%", avgSalary: "€48,000–€65,000", topEmployers: ["Airbus", "DLR", "Bundeswehr", "thyssenkrupp", "Fraunhofer"] },
    intakes: ["October (Winter Semester)", "April (Summer Semester)"], istpStudents: 5,
  },

  "haw-hamburg": {
    slug: "haw-hamburg", country: "germany",
    name: "Hamburg University of Applied Sciences", shortName: "HAW Hamburg", flag: "🇩🇪",
    city: "Hamburg", founded: 1970, qsRank: "Top UAS Germany",
    heroImg: "https://images.unsplash.com/photo-1467269204594-9661b134dd2b?q=80&w=1600&auto=format&fit=crop",
    campusImg: "https://images.unsplash.com/photo-1541339907198-e08756dedf3f?q=80&w=900&auto=format&fit=crop",
    overview: "Northern Germany's largest university of applied sciences with 17,000+ students. Strong in engineering, life sciences, and design. Deep ties to Hamburg's port, media, and aviation industries.",
    tuition: { domestic: "€0", international: "€0" },
    living: "€800–€1,200/mo", ielts: "6.0+", gre: "Not required",
    topCourses: [
      { name: "M.Sc. Computer Science", duration: "1.5 years", language: "English" },
      { name: "M.Sc. Renewable Energy Systems", duration: "1.5 years", language: "English" },
      { name: "M.Sc. Information Technology & Design", duration: "1.5 years", language: "English" },
    ],
    placementStats: { rate: "90%", avgSalary: "€46,000–€62,000", topEmployers: ["Airbus", "Hapag-Lloyd", "Hamburg Port Authority", "Otto Group", "Lufthansa Technik"] },
    intakes: ["October (Winter Semester)", "April (Summer Semester)"], istpStudents: 4,
  },

  "hs-munich": {
    slug: "hs-munich", country: "germany",
    name: "Munich University of Applied Sciences", shortName: "HM Munich", flag: "🇩🇪",
    city: "Munich, Bavaria", founded: 1971, qsRank: "Top UAS Germany",
    heroImg: "https://images.unsplash.com/photo-1467269204594-9661b134dd2b?q=80&w=1600&auto=format&fit=crop",
    campusImg: "https://images.unsplash.com/photo-1541339907198-e08756dedf3f?q=80&w=900&auto=format&fit=crop",
    overview: "One of Germany's largest universities of applied sciences with 20,000+ students. Located in Munich's innovation hub with direct industry partnerships with BMW, MAN, and Siemens.",
    tuition: { domestic: "€0", international: "€0" },
    living: "€900–€1,300/mo", ielts: "6.0+", gre: "Not required",
    topCourses: [
      { name: "M.Sc. Applied Computer Science", duration: "1.5 years", language: "English" },
      { name: "M.Sc. Electrical Engineering", duration: "1.5 years", language: "English" },
      { name: "MBA — International Management", duration: "1.5 years", language: "English" },
    ],
    placementStats: { rate: "93%", avgSalary: "€49,000–€67,000", topEmployers: ["BMW", "MAN", "Siemens", "Allianz", "Linde"] },
    intakes: ["October (Winter Semester)", "April (Summer Semester)"], istpStudents: 6,
  },

  "reutlingen-university": {
    slug: "reutlingen-university", country: "germany",
    name: "Reutlingen University", shortName: "Reutlingen Uni", flag: "🇩🇪",
    city: "Reutlingen, Baden-Württemberg", founded: 1855, qsRank: "Top UAS Germany",
    heroImg: "https://images.unsplash.com/photo-1467269204594-9661b134dd2b?q=80&w=1600&auto=format&fit=crop",
    campusImg: "https://images.unsplash.com/photo-1541339907198-e08756dedf3f?q=80&w=900&auto=format&fit=crop",
    overview: "A highly internationally oriented university of applied sciences near Stuttgart. Known for its ESB Business School, one of Germany's most international business schools. Strong industry curriculum.",
    tuition: { domestic: "€0", international: "€0" },
    living: "€700–€950/mo", ielts: "6.0+", gre: "Not required",
    topCourses: [
      { name: "MBA — International Management", duration: "1 year", language: "English" },
      { name: "M.Sc. Engineering Management", duration: "1.5 years", language: "English" },
      { name: "M.Sc. International Business", duration: "1.5 years", language: "English" },
    ],
    placementStats: { rate: "90%", avgSalary: "€47,000–€63,000", topEmployers: ["Bosch", "Daimler", "Hugo Boss", "Miele", "ZF Friedrichshafen"] },
    intakes: ["October (Winter Semester)", "April (Summer Semester)"], istpStudents: 5,
  },

  "hsba-hamburg": {
    slug: "hsba-hamburg", country: "germany",
    name: "HSBA Hamburg School of Business Administration", shortName: "HSBA Hamburg", flag: "🇩🇪",
    city: "Hamburg", founded: 2004, qsRank: "Top Private Business Schools Germany",
    heroImg: "https://images.unsplash.com/photo-1467269204594-9661b134dd2b?q=80&w=1600&auto=format&fit=crop",
    campusImg: "https://images.unsplash.com/photo-1541339907198-e08756dedf3f?q=80&w=900&auto=format&fit=crop",
    overview: "Hamburg's leading private business school founded by the Hamburg Chamber of Commerce. Strong in international management, logistics, and shipping management — heart of Europe's trade hub.",
    tuition: { domestic: "€9,000/yr", international: "€9,000/yr" },
    living: "€900–€1,300/mo", ielts: "6.5+", gre: "Not required",
    topCourses: [
      { name: "MBA — General Management", duration: "1 year", language: "English" },
      { name: "M.Sc. International Business", duration: "1.5 years", language: "English" },
      { name: "M.Sc. Logistics & Supply Chain Management", duration: "1.5 years", language: "English" },
    ],
    placementStats: { rate: "92%", avgSalary: "€52,000–€72,000", topEmployers: ["Hapag-Lloyd", "Unilever", "Airbus", "Hamburg Commercial Bank", "BCG"] },
    intakes: ["September", "March"], istpStudents: 4,
  },
};
